

import Layout from '../../../components/custom/Layout';
import TasksListContent from './Content';

export default function TasksList () {
    return (
        <Layout>
            <TasksListContent displayMode={false} />
        </Layout>
    );
}
